import { Menu, MenuProps, Modal } from "antd";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMemo, useState } from "react";
import { authActions } from "../../../redux/slices";
import { RootState } from "../../../redux/store";
import { AdminType, ClientType, ProfessionalType } from "../../../types";
import { ModalContentWrapper, NavText, SignOutBtn, StyledSider } from "./style";

const ClientSidebar = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const [showSignoutModal, setShowSignoutModal] = useState<boolean>(false);
  const auth = authActions;

  const isClient = (user: ProfessionalType | ClientType | AdminType | null): user is ClientType => {
    return !!user && "professionalCode" in user;
  };

  const onSignOut = () => {
    setShowSignoutModal(false);

    Cookies.remove("user");
    Cookies.remove("auth_token");
    Cookies.remove("admin_user");
    Cookies.remove("admin_auth_token");

    auth.removeAuth();
    window.location.href = '/signin';
  };

  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);
  const cleanedPath = segments[segments.length - 1];

  const navItems = useMemo(() => [
    {
      icon: <i className="material-icons-outlined icon-font">dashboard</i>,
      label: isClient(user) ? <NavText to={`/c/${user.professionalCode}`}>Dashboard</NavText> : null,
      key: isClient(user) ? `${user.professionalCode}` : "dashboard",
    },
    {
      icon: <i className="material-icons-outlined icon-font">contact_page</i>,
      label: <NavText to="general_client_info">My Info</NavText>,
      key: "general_client_info",
    },
    {
      icon: <i className="material-icons-outlined icon-font">message</i>,
      label: <NavText to="/">Inmail</NavText>,
      key: "inmail",
    },
    {
      icon: <i className="material-icons-outlined icon-font">power_settings_new</i>,
      label: <SignOutBtn onClick={() => setShowSignoutModal(true)}>Sign Out</SignOutBtn>,
      key: "sign_out",
    },
  ], [user]);

  const userProfessionalCode = isClient(user) ? user.professionalCode : null;

  const activeIndex = useMemo(() => {
    const index = navItems?.findIndex((item) => cleanedPath.startsWith(item?.key as string) || (item.key === userProfessionalCode && cleanedPath === userProfessionalCode));
    return index !== -1 ? (index + 1).toString() : "1";
  }, [cleanedPath, navItems, userProfessionalCode]);

  const [collapsed, setCollapsed] = useState<boolean>(false);
  const items: MenuProps["items"] = navItems.map((item, index) => ({
    key: String(index + 1),
    icon: item.icon,
    label: item.label,
  }));

  const handleBack = () => {
    setShowSignoutModal(false);
  };

  return (
    <StyledSider
      collapsible
      collapsed={collapsed}
      breakpoint="xs"
      // collapsedWidth="0"
      onCollapse={(value) => setCollapsed(value)}
      style={{
        overflow: "auto",
        height: "100vh",
        position: "sticky",
        left: 0,
        top: 0,
      }}
    >
      <Modal
        title={`Signout`}
        open={showSignoutModal}
        onOk={onSignOut}
        onCancel={handleBack}
        // footer={null}
        width={350}
      >
        <ModalContentWrapper>
          <span>Are you sure you want to sign out?</span>
        </ModalContentWrapper>
      </Modal>
      <Menu mode="inline" defaultSelectedKeys={["1"]} items={items} selectedKeys={[activeIndex!]} />
    </StyledSider>
  );
};

export default ClientSidebar;
